import React, { Component } from 'react'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'

export default class DeleteRow extends Component {
    constructor(props) {
        super(props)
    }

    componentWillMount() {
        this.setState({
            open : false
        });
    }

    onClose = () => {
        this.setState(
            { open: false }
        )
    }

    onOpen = () => {
        this.setState(
            { open: true }
        )
    }

    onDelete = (email)  => {
         return this.props.delUser(email)
    }
    render() {
        const {rowId, userId, delUser} = this.props;
        const {open} = this.state;
        return (
            <Modal size='tiny' open={open} dimmer='inverted' trigger={<Icon name='trash' size='large' onClick={this.onOpen}/>} >
                <Modal.Header>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='trash'/>
                        </Icon.Group>
                        Delete user {userId}?
                    </Header>
                </Modal.Header>
                <Modal.Content>
                    Are you sure want delete user with email {userId}?
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => this.onDelete(userId)}>
                        <Icon name='remove'/>Delete user
                    </Button>
                    <Button onClick={this.onClose}>
                        <Icon name='user cancel' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}
